<template>
  <div>
    <ins class="adsbygoogle"
      style="display:inline-block;"
      data-ad-client="ca-pub-5310971739125617"
      :data-ad-slot="adSlot"
      data-ad-format="auto"
      data-full-width-responsive="true">
    </ins>
  </div>
</template>

<script>
  export default {
    props: {
      adSlot: Number
    },
    mounted() {
      try {
        (adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {}
    }
  }
</script>
